import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindCarrouselCatalogueContent($id: String!)
{
  findCarrouselCatalogueContent(id: $id) {
    data {
      products {
        iv {
          id
          hideBrandName
          hideProductName
          hidePrice
        }
      }

    }
  }
}`,
]);
